export default {
    namespaced: true,
    state: {
        selectedOrganizationID: null,
        organizations: [],
        showBanner: null,
        organizationRegistration: null
    },
    getters: {
        selectedOrganization(state) {
            return state.organizations.find(organization => organization.id === state.selectedOrganizationID);
        }
    },
    mutations: {
        setOrganizations: (state, val) => state.organizations = val,
        setSelectedOrganizationID: (state, val) => state.selectedOrganizationID = val,
        setShowBanner: (state, val) => state.showBanner = val,
        setOrganizationRegistration: (state, val) => state.organizationRegistration = val,
    },
};
